import type { IconSvgObject } from './types';

const Tap03Icon: IconSvgObject = [
  ["path", { d: "M7.37124 12.671L9.50514 14.5V5.99743C9.50514 5.17042 10.1756 4.5 11.0026 4.5C11.8296 4.5 12.5 5.17042 12.5 5.99743V11H16.5C18.1569 11 19.5 12.3431 19.5 14V19C19.5 20.6569 18.1569 22 16.5 22H10.57C9.9015 22 9.27719 21.666 8.90622 21.1099L4.88941 15.0883C4.37331 14.4531 4.36987 13.5441 4.88114 12.905C5.49565 12.1369 6.62437 12.0308 7.37124 12.671Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6C7 3.79086 8.79086 2 11 2C13.2091 2 15 3.79086 15 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tap03Icon;
